import axios from "axios"

let API_NAME = process.env.VUE_APP_API_NAME;

export default {
  saveApplication(data) {
    let res = axios.post(API_NAME + "/applications", data);
    return res;
  },
  async updateApplication(accessToken, id, data) {
    let res = await axios.put(API_NAME + "/applications/" + id, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveApplicationFunding(accessToken, data) {
    let res = await axios.post(API_NAME + "/fundings", data, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getApplications(accessToken, status, governing_body_id, council_area_id, order_by, round_id, coaching_only) {
    let res = await axios.get(API_NAME + "/applications?status=" + status + "&order_by=" + order_by + "&governing_body_id=" + governing_body_id + "&council_area_id=" + council_area_id + "&round_id=" + round_id + "&coaching_only=" + coaching_only, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
   async getApplicationsNoContact(accessToken) {
    let res = await axios.get(API_NAME + "/applications?no_contact=1&order_by=applications.id", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getFundedAthletes(accessToken, status, governing_body_id, council_area_id, order_by, round_id) {
    let res = await axios.get(API_NAME + "/fundings?status=" + status + "&order_by=" + order_by + "&governing_body_id=" + governing_body_id + "&council_area_id=" + council_area_id + "&round_id=" + round_id, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getAthletesBreakdown(accessToken, minimum_round_id) {
    let res = await axios.get(API_NAME + "/applications?minimum_round_id=" + minimum_round_id + "&include_age=1", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async  getApplicationSummary(accessToken) {
    let res = await axios.get(API_NAME + "/applications?summary=1", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
 
  async getGoverningBodies(accessToken) {
    let res = await axios.get(API_NAME + "/governing_bodies", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getRounds(accessToken) {
    let res = await axios.get(API_NAME + "/rounds", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getCouncilAreas(accessToken) {
    let res = await axios.get(API_NAME + "/council_areas", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getGoverningBodiesWithUsers(accessToken) {
    let res = await axios.get(API_NAME + "/governing_bodies_users", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getApplication(accessToken, id) {
    let res = await axios.get(API_NAME + "/applications/" + id, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async endorseApplication(accessToken, eventID, endorsed) {
    let res = await axios.post(API_NAME + "/applications/" + eventID,  {
            'endorsed' : endorsed,
			    _method: 'patch'
        },
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
        
      });
      
    return res.data;
  },
  async awardApplication(accessToken, eventID, awarded) {
    let res = await axios.post(API_NAME + "/applications/" + eventID,  {
            'awarded' : awarded,
			    _method: 'patch'
        },
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
        
      });
      
    return res.data;
  },
  async linkContact(accessToken, applicationId, contactId) {
    let res = await axios.post(API_NAME + "/applications/" + applicationId, {
      contact_id: contactId,
      _method: 'patch'
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return res.data;
  },
  async saveRankingOrders(accessToken, applications) {
    let res = await axios.post(API_NAME + "/applications/actions/save_ranking_orders",  {
            'applications' : applications,
			    _method: 'patch'
        },
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
        
      });
      
    return res.data;
  },
  async uploadFile(accessToken, formData) {
    let res = await axios.post(API_NAME + "/application_uploads",  
        formData,
        {
          headers: {
          Authorization: `Bearer ${accessToken}`
        }
        
      });
      
    return res.data;
  }
}